export default path => '/black-friday'.includes(path)
